module.exports = __webpack_public_path__ + "static/method-detail-top-5d0568570f454ba712997cff0249bd4f.png";